import { useCallback } from 'react'

import { importDependency } from 'core-components/helpers'
import { useImportDependency } from 'core-components/hooks/useImportDependency'
import InitializationServiceDialer from 'dialer/classes/services/InitializationServiceDialer'
import InitializationServiceHpscm from 'hpscm/classes/services/InitializationService'
import { wsConnectionPool } from 'src/core/classes/ws/WSConnectionPool'
import { AppLoader } from 'src/core/components/app/AppLoader'
import { CoreLoaderWrapper, ILoader } from 'src/core/components/app/loaders'

const importWrappersModuleFederation = {
  kbase: {
    key: 'remoteKbase/KBaseLoaderWrapper',
    importFn: () => import('remoteKbase/KBaseLoaderWrapper'),
  },
  docflow: {
    key: 'remoteDocflow/DebuggerLoaderWrapper',
    importFn: () => import('remoteDocflow/DebuggerLoaderWrapper'),
  },
  orgchart: {
    key: 'remoteOrgchart/OrgchartLoaderWrapper',
    importFn: () => import('remoteOrgchart/OrgchartLoaderWrapper'),
  },
}

export const LoaderWrapper = ({ children, ...props }: ILoader) => {
  const { isDependencyLoading: isKbaseWrapperLoading, Module: KbaseModuleWrapper } =
    useImportDependency({
      key: importWrappersModuleFederation.kbase.key,
      importFunction: importWrappersModuleFederation.kbase.importFn,
      defaultValue: ({ children }) => children,
    })

  const { isDependencyLoading: isDocflowWrapperLoading, Module: DocflowModuleWrapper } =
    useImportDependency({
      key: importWrappersModuleFederation.docflow.key,
      importFunction: importWrappersModuleFederation.docflow.importFn,
      defaultValue: ({ children }) => children,
    })

  const { isDependencyLoading: isOrgchartWrapperLoading, Module: OrgchartModuleWrapper } =
    useImportDependency({
      key: importWrappersModuleFederation.orgchart.key,
      importFunction: importWrappersModuleFederation.orgchart.importFn,
      defaultValue: ({ children }) => children,
    })

  const isWrappersLoading =
    isKbaseWrapperLoading || isDocflowWrapperLoading || isOrgchartWrapperLoading

  const beforeInitCallback = useCallback(async () => {
    wsConnectionPool.initWSPool(import.meta.env.VITE_WS_SERVERS)

    InitializationServiceHpscm.init()
    InitializationServiceDialer.init().catch(console.error)

    await Promise.all([
      importDependency(
        'pf/beforeInitCallback',
        () => import('pf/beforeInitCallback'),
        (callback) => callback()
      ),
    ])
  }, [])

  if (isWrappersLoading) {
    return <AppLoader />
  }

  return (
    <CoreLoaderWrapper {...props} beforeInitCallback={beforeInitCallback}>
      <KbaseModuleWrapper>
        <OrgchartModuleWrapper>
          <DocflowModuleWrapper>{children}</DocflowModuleWrapper>
        </OrgchartModuleWrapper>
      </KbaseModuleWrapper>
    </CoreLoaderWrapper>
  )
}
